import styled, { css } from 'styled-components';
import { GYPSUM, OBSIDIAN } from 'HubStyleTokens/colors';
import { H1, H2 } from 'UIComponents/elements/headings';
export const PageHeader = styled.header.withConfig({
  displayName: "SharedComponents__PageHeader",
  componentId: "vk5m0e-0"
})(["text-align:", ";margin:auto;padding:0 1rem;"], ({
  textAlign
}) => textAlign || 'center');
export const PageTitle = styled(H1).attrs({
  // H1 aria-level default is 2
  'aria-level': 1
}).withConfig({
  displayName: "SharedComponents__PageTitle",
  componentId: "vk5m0e-1"
})(["font-size:2rem;font-weight:900;margin-bottom:16px;line-height:2.5rem;"]);
export const PageSubTitle = styled.p.withConfig({
  displayName: "SharedComponents__PageSubTitle",
  componentId: "vk5m0e-2"
})(["font-size:1rem;color:", ";"], OBSIDIAN);
export const Section = styled.section.withConfig({
  displayName: "SharedComponents__Section",
  componentId: "vk5m0e-3"
})(["width:100%;position:relative;padding:", ";overflow:", ";", " ", ""], ({
  padding
}) => padding || '16px 0 60px', ({
  hideOverflow = true
}) => hideOverflow ? 'hidden' : 'visible', ({
  margin
}) => {
  return `margin: ${margin};` || null;
}, ({
  use
}) => {
  if (use === 'shaded') {
    return css(["background-color:", ";"], GYPSUM);
  }

  return null;
});
export const SectionHeader = styled.div.withConfig({
  displayName: "SharedComponents__SectionHeader",
  componentId: "vk5m0e-4"
})(["text-align:", ";max-width:710px;margin:20px auto;"], ({
  textAlign
}) => textAlign || 'center');
export const SectionTitle = styled(H2).withConfig({
  displayName: "SharedComponents__SectionTitle",
  componentId: "vk5m0e-5"
})(["font-weight:600;margin-top:0;margin-bottom:8px;"]);
export const SectionSubTitle = styled.p.withConfig({
  displayName: "SharedComponents__SectionSubTitle",
  componentId: "vk5m0e-6"
})(["margin-bottom:24px;"]);